import axios from 'axios'
import { API_HOST } from '../../config/app-const';

const pagination = {
  perPage: 50,
  currentPage: 0,
  totalPages: 0,
  totalCount: 0,
}

const filters = {
  sort: 'asc',
  order: 'label',
  query: null
}

const state = {
  outlet_groups: {
    isBusy: false,
    isInitiated: false,
    deletedQuery: null,
    data: [],
    pagination: {...pagination},
    filters: {...filters}
  }
}

const mutations = {
  SET_BUSY(state, payload) {
    state.outlet_groups.isBusy = payload
  },
  SET_INITIATE_STATE(state, payload) {
    state.outlet_groups.isInitiated = payload
  },
  SET_QUERY(state, query) {
    state.outlet_groups.filters.query = query
  },
  SET_PROJECTID(state, project_id){
    state.outlet_groups.filters.project_id = project_id
  },
  SET_OUTLET_GROUPS(state, { resourceData, pagination:responsePagination, reset = false}) {
    if(reset) {
      state.outlet_groups.isInitiated = false
      state.outlet_groups.data = []
      state.outlet_groups.pagination = {...pagination}
    }
    resourceData.forEach(item => state.outlet_groups.data.push(item))
    state.outlet_groups.pagination = { ...state.outlet_groups.pagination, ...responsePagination }
    state.outlet_groups.isInitiated = true
  },
  RESET_PAGINATION(state) {
    state.outlet_groups.pagination = { ...pagination }
  },
  RESET_FILTERS(state) {
    state.outlet_groups.filters = { ...filters }
  }
}

const getters = {}

const actions = {
  getOutletGroups({commit, state, rootState}, {projectId, query}) {
    // if query, set it up on corresponding object
    if(query) commit('SET_QUERY', query)
    if (projectId) commit('SET_PROJECTID', projectId);
    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    let { currentPage, totalPages, perPage } = state.outlet_groups.pagination
    const currentPagination = { currentPage, perPage }
    const filters = state.outlet_groups.filters
    // if query request, always load page 1
    const requestPagination = query ? pagination : currentPagination
    let url = getNextPageUrl('outlets/outlet_groups', requestPagination, filters);
    url = `${API_HOST}${url}`;
    return new Promise((resolve, reject) => {

      if(currentPage && currentPage >= totalPages) reject()
      commit('SET_BUSY', true)
      axios.get(url, config)
        .then(({data}) => {
          const {status, data : { data: resourceData, pagination } } = data
          commit("SET_OUTLET_GROUPS", { resourceData, pagination, reset : pagination.currentPage === 1})
          resolve(data)
        })
        .catch((e) => reject(e))
        .finally(() => {
          commit('SET_BUSY', false)
          commit('SET_INITIATE_STATE', true)
        })
    })
  },
}

// This function forms query string for "NextPage" call
function getNextPageUrl(url, pagination, filters) {
  if(!url || url === '' || !pagination || !Object.keys(pagination).length) return console.error('Cannot form url for api call. Something is missing')
  if(!url.startsWith('/')) url = `/${url}`

  let paginationString = Object.entries(pagination).map(([key, val]) => `${key}=${ key === 'currentPage' ? val + 1 : val}`).join('&')
  const filterString = Object.entries(filters).map(([key, val]) =>  val ? `${key}=${val}` : null).filter(item => item).join('&')
  if(filterString.length) paginationString = `${paginationString}&${filterString}`

  return `${url}?${paginationString}`
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};